import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import { useTranslation } from "react-i18next";
import SubCategory from "../src/Json/SubCategory.json";
import brands from "../src/Json/Brand.json";
function LibasMenuShoes({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) {
  const { i18n, t } = useTranslation();
  console.log(expandedSubcategories, "this is exapand");

  const ShoesMen = [
    {
      name: "Boots",
    },
    {
      name: "Espadrilles",
    },
    {
      name: "Flat shoes",
    },
    {
      name: "Lace-ups",
    },
    {
      name: "Sandals",
    },
    {
      name: "Trainers",
    },
  ];
  const ShoesDesigners = [
    {
      name: "Christian Louboutin",
    },
    {
      name: "Hermès",
    },
    {
      name: "Saint Laurent",
    },
    {
      name: "Fendi",
    },
    {
      name: "Chanel",
    },
    {
      name: "Gucci",
    },
    {
      name: "Louis Vuitton",
    },
    {
      name: "Dior",
    },
    {
      name: "Miu Miu",
    },
    {
      name: "Prada",
    },

    {
      name: "Celine",
    },
    {
      name: "Bottega Veneta",
    },
    {
      name: "Amina Muaddi",
    },
    {
      name: "Nike",
    },
    {
      name: "Jimmy Choo",
    },
  ];
  const ShoesWomen = [
    {
      name: "Sandals",
    },

    {
      name: "Trainers",
    },
    {
      name: "Boots",
    },
    {
      name: "Espadrilles",
    },
    {
      name: "Flat shoes",
    },

    {
      name: "Mules & Clogs",
    },
    {
      name: "Heels",
    },

    {
      name: "Ballet flats",
    },
    {
      name: "Lace ups",
    },

    {
      name: "Ankle boots",
    },
  ];

  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* Womens */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("shoesmain")}
          style={{
            borderBottom:
              expandedCategory === "shoesmain" ? "none" : "1px solid #dee2e6",
            borderBottomColor:
              expandedCategory === "shoesmain" ? "#333" : "#eee",
            borderBottomWidth: expandedCategory === "shoesmain" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <Link
            to="/products?id=WJmwaMSWxtl1dK1sPZ1x"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "shoesmain") {
                setHide(true);
                return;
              } else {
                setActiveFilter("shoesmain");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#404040",
                fontWeight: expandedCategory === "shoesmain" ? "500" : "400",
                textDecoration:
                  expandedCategory === "shoesmain" ? "underline" : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("Shoes")}
            </motion.span>
          </Link>

          {/* Animated arrow icon */}
          <motion.div
            animate={{ rotate: expandedCategory === "mens" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "shoesmain" ? menuup : menudown}
              alt="menudown"
            />
          </motion.div>
        </motion.div>
        <AnimatePresence>
          {expandedCategory === "shoesmain" && (
            <motion.div
              className="subcategory-container p-1 px-3"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={categoryContainerVariants}
            >
              <div className="row">
                <div className="col-12 p-0">
                  {/* submenus of shoesmain */}
                  <ul className="list-unstyled">
                    {/* clothes with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&`}
                          className="subtitlemega "
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "shoesmain") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("shoesmain");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{
                              marginLeft: "15px",
                            }}
                            onClick={() =>
                              navigateToCategory("shoesmain", "clothes")
                            }
                          >
                            {t("Designers")}
                          </motion.button>
                        </Link>
                        {/* Animated arrow for subcategory */}
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("shoesdesigners");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.shoesdesigners
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.shoesdesigners
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for women clothes */}
                      <AnimatePresence>
                        {expandedSubcategories.shoesdesigners && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {ShoesDesigners?.map((brandsection) =>
                              brands
                                ?.filter(
                                  (brand) => brand?.name === brandsection?.name
                                )
                                ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
                                ?.map((brand) => (
                                  <Link
                                    key={brand?.id}
                                    to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&brand=${brand.id}&nameBrand=${brand.name}`}
                                    className="subtitlemega"
                                    onClick={() => {
                                      if (activeFilter === "shoes") {
                                        setHide(true);
                                        return;
                                      } else {
                                        setActiveFilter("shoes");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.li
                                      className="py-1"
                                      variants={nestedItemVariants}
                                    >
                                      <motion.button
                                        className="btn btn-link text-decoration-none p-0 text-dark small"
                                        whileHover={{ x: 3, color: "#000" }}
                                        onClick={() =>
                                          navigateToCategory(
                                            "shoes",
                                            "brand",
                                            brand?.slug ||
                                              brand?.name?.toLowerCase()
                                          )
                                        }
                                      >
                                        {i18n.language === "en"
                                          ? brand?.name
                                          : brand?.nameAr}
                                      </motion.button>
                                    </motion.li>
                                  </Link>
                                ))
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/*       {t("Women")} with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "shoesmain") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("shoesmain");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("shoesmain", "shoesmain")
                            }
                          >
                            Women's
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("Womenshoess");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.Womenshoess ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.Womenshoess
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for women */}
                      <AnimatePresence>
                        {expandedSubcategories?.Womenshoess && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {SubCategory?.filter(
                              (subcat) =>
                                subcat.idTypeCategory ===
                                  "WJmwaMSWxtl1dK1sPZ1x" &&
                                ShoesWomen.some(
                                  (shoe) => shoe.name === subcat.name
                                )
                            )
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((sub) => (
                                <Link
                                  key={sub.id}
                                  to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "shoes") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("shoes");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "shoes",
                                          "subcategory",
                                          sub.slug || sub.name.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* Men with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to="/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "shoesmain") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("shoesmain");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("shoesmain", "mens")
                            }
                          >
                            Men's
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("shoesmenss");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.shoesmenss ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.shoesmenss
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for mensshoees */}
                      <AnimatePresence>
                        {expandedSubcategories?.shoesmenss && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {ShoesMen?.map((shoes) =>
                              SubCategory.filter(
                                (subcat) => subcat.name === shoes.name
                              )
                                .sort((a, b) => (a.name > b.name ? 1 : -1))
                                .map((sub) => (
                                  <Link
                                    key={sub.id}
                                    to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega"
                                    onClick={() => {
                                      if (activeFilter === "shoes") {
                                        setHide(true);
                                        return;
                                      } else {
                                        setActiveFilter("shoes");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.li
                                      className="py-1"
                                      variants={nestedItemVariants}
                                    >
                                      <motion.button
                                        className="btn btn-link text-decoration-none p-0 text-dark small"
                                        whileHover={{ x: 3, color: "#000" }}
                                        onClick={() =>
                                          navigateToCategory(
                                            "shoes",
                                            "subcategory",
                                            sub.slug || sub.name.toLowerCase()
                                          )
                                        }
                                      >
                                        {i18n.language === "en"
                                          ? sub.name
                                          : sub.nameAr}
                                      </motion.button>
                                    </motion.li>
                                  </Link>
                                ))
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                  </ul>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default LibasMenuShoes;
